<template>
  <div class="card edit-card">
    <div class="card-body">
      <div class="edit-grid">
        <!-- Basic Info -->
        <div class="edit-section">
          <h6 class="section-title"><i class="fas fa-store mr-2"></i>基本情報</h6>
          <div class="field-group">
            <label>店舗名 <span class="required">*</span></label>
            <input type="text" class="form-control" v-model="formData.shop_name">
          </div>
          <div class="field-row">
            <div class="field-group">
              <label>郵便番号 <span class="required">*</span></label>
              <input type="text" class="form-control" v-model="formData.postal_code" placeholder="ハイフンなし" @keypress="validateNumber">
            </div>
            <div class="field-group">
              <label>電話番号 <span class="required">*</span></label>
              <input type="text" class="form-control" v-model="formData.tel_number" placeholder="ハイフンなし" @keypress="validateNumber">
            </div>
          </div>
          <div class="field-group">
            <label>住所 <span class="required">*</span></label>
            <textarea class="form-control" rows="3" v-model="formData.address"></textarea>
          </div>
          <div class="field-group">
            <label>URL</label>
            <input type="text" class="form-control" v-model="formData.url">
          </div>
        </div>

        <!-- Settings -->
        <div class="edit-section">
          <h6 class="section-title"><i class="fas fa-cog mr-2"></i>設定</h6>
          <div class="field-group">
            <label>営業時間</label>
            <div class="time-range">
              <input type="time" class="form-control" v-model="formData.opening_time">
              <span class="range-sep">〜</span>
              <input type="time" class="form-control" v-model="formData.closing_time">
            </div>
          </div>
          <div class="field-group">
            <label>タイムカード調整</label>
            <div class="time-adj-row">
              <label class="toggle-inline">
                <input type="checkbox" v-model="timeAdjustmentEnabled">
                <span>利用する</span>
              </label>
              <select v-if="timeAdjustmentEnabled" v-model="formData.time_adjustment" class="form-control form-control-sm time-adj-select">
                <option value="5">5分</option>
                <option value="15">15分</option>
                <option value="30">30分</option>
              </select>
            </div>
          </div>
          <div class="field-group">
            <label>管理者 <span class="required">*</span></label>
            <p class="field-hint">管理者に設定するスタッフにチェックを入れてください</p>
            <div class="manager-checklist">
              <label v-for="staff in allStaff" :key="staff.id" class="manager-check-item">
                <input type="checkbox" :value="staff.id" v-model="selectedManagers">
                <span class="manager-name">{{ staff.name }}</span>
              </label>
              <p v-if="allStaff.length === 0" class="text-muted">スタッフが登録されていません</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer detail-footer">
      <button class="btn btn-outline-secondary" @click="cancel">
        <i class="fas fa-times mr-1"></i>キャンセル
      </button>
      <button class="btn btn-primary" @click="save">
        <i class="fas fa-save mr-1"></i>保存
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formData: {
        shop_name: null,
        postal_code: null,
        address: null,
        tel_number: null,
        url: null,
        opening_time: '',
        closing_time: '',
        company_id: this.$store.getters.company,
        time_adjustment: 0,
      },
      allStaff: [],
      selectedManagers: [],
      timeAdjustmentEnabled: false,
    }
  },
  watch: {
    timeAdjustmentEnabled(val) {
      if (!val) {
        this.formData.time_adjustment = 0;
      } else if (!this.formData.time_adjustment || this.formData.time_adjustment == 0) {
        this.formData.time_adjustment = 5;
      }
    }
  },
  mounted() {
    this.getShopDetails();
  },
  methods: {
    validateNumber(event) {
      const key = event.key;
      if (!/[0-9]/.test(key)) {
        event.preventDefault();
      }
    },
    getShopDetails () {
      this.$http.get(process.env.VUE_APP_API_PATH + '/company/shop/' + this.$route.params.shop_id)
      .then(response => {
        const data = response.data.data;
        this.formData = {
          shop_name: data.shop_name,
          postal_code: data.postal_code,
          address: data.address,
          tel_number: data.tel_number,
          url: data.url,
          opening_time: data.opening_time ? data.opening_time.slice(0, 5) : '',
          closing_time: data.closing_time ? data.closing_time.slice(0, 5) : '',
          company_id: this.$store.getters.company,
          time_adjustment: data.time_adjustment || 0,
        };
        this.allStaff = data.staff || [];
        this.selectedManagers = this.allStaff
          .filter(s => s.pivot && s.pivot.manager_flag)
          .map(s => s.id);
        if (data.time_adjustment > 0) {
          this.timeAdjustmentEnabled = true;
        }
      })
      .catch(error => {
        console.log(error);
      });
    },
    cancel () {
      this.$router.push({name:'CompanyShopDetailsPage', params: {shop_id: this.$route.params.shop_id}});
    },
    save () {
      const payload = {
        ...this.formData,
        managers: this.selectedManagers,
      };
      if (!this.timeAdjustmentEnabled) {
        payload.time_adjustment = 0;
      }
      this.$http.put(process.env.VUE_APP_API_PATH + '/company/shop/' + this.$route.params.shop_id, payload)
      .then(response => {
        if (response.data.success) {
          this.$toast.success(response.data.message);
          setTimeout(() => {
            this.$router.push({name:'CompanyShopDetailsPage', params: {shop_id: this.$route.params.shop_id}});
          }, 1500);
        }
      })
      .catch(error => {
        if (error.response) {
          const response = error.response.data;
          if (error.response.status === 422) {
            this.$toast.error('未入力の必須項目があります');
          } else {
            this.$toast.error(response.message);
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.edit-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
}

@media (max-width: 768px) {
  .edit-grid {
    grid-template-columns: 1fr;
  }
}

.section-title {
  font-size: 14px;
  font-weight: 700;
  color: #049C4C;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding-bottom: 10px;
  margin-bottom: 16px;
  border-bottom: 2px solid #e2e8f0;
}

.field-group {
  margin-bottom: 16px;
}

.field-group label {
  font-size: 13px;
  font-weight: 600;
  color: #4a5568;
  margin-bottom: 4px;
  display: block;
}

.field-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.time-range {
  display: flex;
  align-items: center;
  gap: 8px;
}

.range-sep {
  color: #718096;
  font-weight: 600;
}

.required {
  color: #e53e3e;
  font-weight: 700;
}

.detail-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background: #f7fafc;
  border-top: 1px solid #e2e8f0;
}

/* Time adjustment */
.time-adj-row {
  display: flex;
  align-items: center;
  gap: 16px;
}

.toggle-inline {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #2d3748;
  margin: 0;
}

.toggle-inline input[type="checkbox"] {
  width: 18px;
  height: 18px;
  accent-color: #049C4C;
}

.time-adj-select {
  width: 100px;
}

/* Manager checklist */
.field-hint {
  font-size: 12px;
  color: #718096;
  margin-bottom: 8px;
  margin-top: 0;
}

.manager-checklist {
  max-height: 280px;
  overflow-y: auto;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 8px;
  background: #f7fafc;
}

.manager-check-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  margin: 0;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.manager-check-item:hover {
  background: #f0fff4;
}

.manager-check-item input[type="checkbox"] {
  width: 18px;
  height: 18px;
  accent-color: #049C4C;
  flex-shrink: 0;
}

.manager-name {
  font-size: 14px;
  font-weight: 500;
  color: #1a202c;
}
</style>
